import Title from "../components/Title";
import Paragraph from "../components/Paragraph";
import SocialLinks from "../components/SocialLinks";

const InitialScreen = () => {
  return (
    <div>
      <header className="hero">
        <p className="prompt-line">
          <span className="prompt-symbol">$</span>whoami
        </p>
        <h1 className="hero-name">Ishak Ertem</h1>
        <p className="hero-role">
          Senior Software Engineer
          <span className="cursor" />
        </p>
        <p className="hero-tags">
          <span>web</span> · <span>mobile</span> · <span>kiosk</span> ·{" "}
          <span>desktop</span>
        </p>
      </header>

      <section className="section">
        <Title title="About me" />
        <Paragraph>
          Hi there! I am a senior software engineer with a proven history of
          delivering innovative solutions across web, mobile, kiosk, and
          desktop environments. I am proficient in React, React Native,
          TypeScript, Next.js, Node.js, Electron, Python, FastAPI, MySQL, and
          NoSQL databases, with solid experience building real-time features
          on WebSockets. I hold a Bachelor’s degree in Computer Information
          Systems from CUNY Baruch College.
        </Paragraph>
        <Paragraph>
          I take pride in my contributions to projects that serve millions of
          people, and I am well-versed in leveraging monorepo structures to
          streamline development across platforms.
        </Paragraph>
        <Paragraph>
          One of my key strengths is how quickly I learn new languages and
          technologies — most recently, I picked up Clarion, a legacy 4GL, in
          six months in order to migrate existing systems to Python and React
          Native. That drive for continuous learning keeps me at the forefront
          of an ever-evolving technology landscape.
        </Paragraph>
      </section>

      <section className="section">
        <Title title="Education" />
        <div className="entry">
          <h3 className="entry-title">
            City University of New York — Baruch College
          </h3>
          <p className="entry-meta">
            <span className="entry-company">
              Computer Information Systems, Information Risk Management and
              Cyber Security
            </span>{" "}
            · Dec 2017
          </p>
        </div>
      </section>

      <section className="section">
        <Title title="Contact" />
        <SocialLinks />
      </section>
    </div>
  );
};

export default InitialScreen;
